<template>
    <kt-panel>
        <div class="fh-datatable">
            <div style="text-align: center;" class="mb-3 mt-2">
                {{ $t('reports.users.report') }} {{ officialFactor.from_date }} - {{ officialFactor.to_date }}
            </div>
            <table class="table table-striped">
                <thead>
                <tr style="font-size: 0.89rem;">
                    <td style="text-align: center; width:70px">#</td>
                    <td style="text-align: center">{{ $t('reports.users.fullname') }}</td>
                    <td style="text-align: center">{{ $t('reports.users.user_level') }}</td>
                    <td style="text-align: center">{{ $t('reports.users.created_at') }}</td>
                    <td style="text-align: center">{{ $t('reports.users.last_update') }}</td>
                    <td style="text-align: center; width: 12%">{{ $t('reports.users.last_ip_login') }}</td>
                    <td style="text-align: center">{{ $t('reports.gateways.total_transactions') }}</td>
                    <td style="text-align: center">{{ $t('reports.gateways.total_wage') }}</td>
                    <td style="text-align: center">{{ $t('reports.gateways.unsettled_balance') }}</td>
                    <td style="text-align: center">{{ $t('reports.actions') }}</td>
                </tr>
                </thead>
                <tbody  v-if="officialFactor.users != null">
                <tr v-bind:key="index" v-for="(user, index) in officialFactor.users">
                    <td style="text-align: center">{{ user.id }}</td>
                    <td style="text-align: center">{{ user.title }}</td>
                    <td style="text-align: center">{{ user.user_level }}</td>
                    <td style="text-align: center">{{ user.created_at }}</td>
                    <td style="text-align: center">{{ user.last_update }}</td>
                    <td style="text-align: center">{{ user.last_ip_login }}</td>
                    <td style="text-align: center">{{ user.total_transactions }}</td>
                    <td style="text-align: center">{{ user.total_wage }}</td>
                    <td style="text-align: center">{{ user.unsettled_balance }}</td>
                    <td style="text-align: center">
                        <button type="button" style="background: none; border: none; color: #7878e4"
                                @click="exportExcel(user.id, query)">
                            <i class="fa fa-download"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="loader" style="display:none"></div>
    </kt-panel>
</template>

<script>
    import { mapGetters } from 'vuex'
    import toastr from "toastr";
    import $ from "jquery";
    import axios from "axios";
    import { ApiUrl } from '@/common/api.service'
    import { i18n } from '@/plugins/i18n'

    export default {
        props: {
            officialFactor: {
                required: true
            },
            query : {
                required: true
            }
        },

        computed: {
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-bottom-center",
                    preventDuplicates: false,
                    rtl: false
                }

                return toastr
            }
        },

        mounted() {

        },

        methods: {
            exportExcel(userId, query) {
                $('.loader').addClass('disp_block')

                axios({
                    url: ApiUrl.path('reports/factor-excel-export'),
                    method: 'GET',
                    params: {
                        'query' : query,
                        'hashid': userId
                    },
                })
                    .then(
                    response => {
                        $('.loader').removeClass('disp_block')
                        var fileLink = document.createElement('a');
                        fileLink.href = response.data.data;
                        fileLink.setAttribute('download', 'factor_export.xlsx');
                        document.body.appendChild(fileLink);

                        fileLink.click();
                    },
                    error => {
                        $('.loader').removeClass('disp_block')
                        this.toastr.error(i18n.t('reports.tax.failedMessage'))
                     });
            }
        }
    }
</script>